"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var getClassNames = Utilities_1.classNamesFunction();
/**
 * {@docCategory Announced}
 */
var AnnouncedBase = /** @class */ (function (_super) {
    tslib_1.__extends(AnnouncedBase, _super);
    function AnnouncedBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnouncedBase.prototype.render = function () {
        var _a = this.props, message = _a.message, styles = _a.styles;
        this._classNames = getClassNames(styles);
        return (React.createElement("div", tslib_1.__assign({ role: "status" }, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties)),
            React.createElement(Utilities_1.DelayedRender, null,
                React.createElement("div", { className: this._classNames.screenReaderText }, message))));
    };
    AnnouncedBase.defaultProps = {
        'aria-live': 'assertive'
    };
    return AnnouncedBase;
}(React.Component));
exports.AnnouncedBase = AnnouncedBase;
//# sourceMappingURL=Announced.base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Announced/Announced.base.js
// module id = 670
// module chunks = 0